import { render } from "./ArticleOfTheDay.vue?vue&type=template&id=af9b1a64"
import script from "./ArticleOfTheDay.vue?vue&type=script&lang=js"
export * from "./ArticleOfTheDay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__